import { createActionGroup, props } from "@ngrx/store";
import { EventDetailed, EventsSource, PreqResult } from "../model";

export enum EventsActions {
  EVENTS_FETCH = "Events fetch",
  EVENTS_FETCH_SUCCESS = "Events fetch success",
  EVENT_FETCH_BY_ID = "Event fetch by id",
  EVENT_FETCH_BY_ID_SUCCESS = "event fetch by id success",
  EVENT_FETCH_BY_ID_FAILURE = "event fetch by id failure",
  EVENT_PRESENCE_FETCH = "Event presence fetch",
  EVENT_PRESENCE_FETCH_SUCCESS = "Event presence fetch success",
  EVENT_PRESENCE_FETCH_FAILURE = "Event presence fetch failure",
  EVENT_PREQ_FETCH_BY_ID = "Event Preq Fetch By Id",
  EVENT_PREQ_FETCH_BY_ID_SUCCESS = "Event Preq Fetch By Id Success",
  EVENT_PREQ_FETCH_BY_ID_FAILURE = "Event Preq Fetch By Id Failure",
  EVENT_PREQ_TABLE_LOADING_CHANGE = "Event Preq Table Loading Change",
}

export const EventsApiActions = createActionGroup({
  source: "Events API",
  events: {
    [EventsActions.EVENTS_FETCH]: props<{ source?: EventsSource }>(),
    [EventsActions.EVENTS_FETCH_SUCCESS]: props<{
      events: Partial<EventDetailed>[];
    }>(),
    [EventsActions.EVENT_FETCH_BY_ID]: props<{ id: number }>(),
    [EventsActions.EVENT_FETCH_BY_ID_SUCCESS]: props<{
      event: Partial<EventDetailed>;
    }>(),
    [EventsActions.EVENT_FETCH_BY_ID_FAILURE]: props<{ param?: unknown }>(),
    [EventsActions.EVENT_PREQ_FETCH_BY_ID]: props<{ eventId: number }>(),
    [EventsActions.EVENT_PREQ_FETCH_BY_ID_SUCCESS]: props<{
      eventId: number;
      eventPreq: PreqResult[];
    }>(),
    [EventsActions.EVENT_PREQ_FETCH_BY_ID_FAILURE]: props<{
      empty?: unknown;
    }>(),
    [EventsActions.EVENT_PREQ_TABLE_LOADING_CHANGE]: props<{
      value: boolean;
      eventId: number;
    }>(),
  },
});
